import { render, staticRenderFns } from "./VoluntaryRealEstate.vue?vue&type=template&id=7769f37c"
import script from "./VoluntaryRealEstate.vue?vue&type=script&lang=ts"
export * from "./VoluntaryRealEstate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports